import { motion, useInView } from "framer-motion"
import { graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const ApplicationForm = ({ module, location }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)
  const [hasSubmitted, setHasSubmitted] = useState(false)

  const selectedJob = location.state?.jobClicked

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const careerData = useStaticQuery(graphql/* GraphQL */ `
    query CareersQuery {
      allWpCareer(sort: { date: DESC }) {
        nodes {
          title
          excerpt
          content
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          careersCategory {
            nodes {
              name
              slug
            }
          }
          CareersContent {
            jobDescription {
              mediaItemUrl
            }
          }
        }
      }
    }
  `)

  const allJobs = careerData.allWpCareer.nodes

  const [isLoading, setIsLoading] = useState(false)

  const [form, setForm] = useState({
    input_1: "",
    input_3: "",
    input_4: "",
    input_5: "",
    input_6: "",
    input_11: selectedJob ? selectedJob : "",
    input_8: "",
    input_9: "",
    input_10: "",
  })

  const [formError, setFormError] = useState({
    input_1: "",
    input_3: "",
    input_4: "",
    input_5: "",
    input_6: "",
    input_11: "",
    input_8: "",
    input_9: "",
    input_10: "",
  })

  const [file, setFile] = useState(null)
  const [file2, setFile2] = useState(null)

  const [prevEntries, setPrevEntries] = useState([])

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization:
          "Basic " +
          btoa(
            "ck_5d834d5d60276748e40ad93817c7e1f695f61f7f:cs_448116eacd6691a066bfc4a873794ed14d872297"
          ),
      },
    }
    const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${
      form.input_11 === "Content Manager"
        ? process.env.GATSBY_CONTENT_MANAGER_APPLICATION_FORM_ID
        : process.env.GATSBY_GENERAL_APPLICATION_FORM_ID
    }/entries`
    fetch(url, requestOptions)
      .then(response => {
        if (response.status === 200) {
          return response.json()
        }
      })
      .then(data => {
        setPrevEntries(data.entries)
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }, [form])

  if (module.hideSection === "no") {
    return (
      <section
        className={`apply-form${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bg-white-100 pt-95 pb-60 lgscreen:py-30">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="anim"
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
                className="w-full max-w-[960px] mx-auto text-center px-20"
              >
                {module?.preHeading && (
                  <div className="preheading mb-5 lgscreen:mb-15">
                    <motion.div
                      variants={animFade}
                      className="font-ositalic text-16 text-charcoal"
                    >
                      {module.preHeading}
                    </motion.div>
                  </div>
                )}
                {module?.heading && (
                  <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                )}
                {module?.description && (
                  <motion.div variants={animFade} className="content">
                    {parse(module.description)}
                  </motion.div>
                )}
                {!hasSubmitted ? (
                  <div className="gform_wrapper mt-50 px-50 smscreen2:px-0 smscreen2:mt-20">
                    <motion.div variants={animFade} className="gform_body">
                      <form>
                        <ul className="flex flex-wrap justify-between smscreen2:flex-col -mx-30 smscreen2:mx-0 mt-30 smscreen2:mt-0 formData">
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_1"
                              >
                                name <span className="text-[#CE0D0D]">*</span>
                              </label>
                              <input
                                type="text"
                                value={form.input_1}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_1: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_1: "",
                                  })
                                }}
                                placeholder="Type here"
                              />
                            </div>
                            {formError.input_1 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_1}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_3"
                              >
                                Surname{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>

                              <input
                                type="text"
                                value={form.input_3}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_3: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_3: "",
                                  })
                                }}
                                placeholder="Type here"
                              />
                            </div>
                            {formError.input_3 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_3}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_4"
                              >
                                Email Address{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>

                              <input
                                type="text"
                                className="text-12 font-primary font-300 leading-20 tracking-012em pb-5 outline-none"
                                value={form.input_4}
                                onBlur={e => {
                                  var value = e.target.value
                                  var pattern =
                                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                                  if (!pattern.test(value)) {
                                    setForm({ ...form, input_4: "" })
                                    setFormError({
                                      ...formError,
                                      input_4: "Please enter valid email.",
                                    })
                                  }
                                }}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_4: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_4: "",
                                  })
                                }}
                                placeholder="Email Address *"
                              />
                            </div>

                            {formError.input_4 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_4}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_5"
                              >
                                phone number{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>

                              <input
                                type="text"
                                value={form.input_5}
                                onBlur={e => {
                                  var value = e.target.value
                                  var pattern = /^[\d -+\s]{1,20}$/
                                  if (!pattern.test(value)) {
                                    setForm({ ...form, input_5: "" })
                                    setFormError({
                                      ...formError,
                                      input_5:
                                        "Please enter valid phone number.",
                                    })
                                  }
                                }}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_5: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_5: "",
                                  })
                                }}
                                placeholder="Type Here"
                              />
                            </div>
                            {formError.input_5 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_5}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_6"
                              >
                                Years of experience{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>
                              <select
                                name=""
                                id=""
                                value={form.input_6}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_6: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_6: "",
                                  })
                                }}
                              >
                                <option>Select</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8+</option>
                              </select>
                            </div>
                            {formError.input_6 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_6}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_11"
                              >
                                Position{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>
                              <select
                                name=""
                                id="dd"
                                value={form.input_11}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_11: e.target.value,
                                  })
                                  setFormError({
                                    ...formError,
                                    input_11: "",
                                  })
                                }}
                              >
                                <option value="">Select</option>

                                {allJobs.map(job => {
                                  return (
                                    <option value={job.title}>
                                      {job.title}
                                    </option>
                                  )
                                })}
                              </select>
                            </div>
                            {formError.input_11 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_11}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-full">
                            <div className="form-group flex flex-wrap lg:mt-0">
                              <label
                                className="text-12 tracking-05em uppercase"
                                htmlFor="input_8"
                              >
                                Message{" "}
                                <span className="text-[#CE0D0D]">*</span>
                              </label>

                              <textarea
                                rows="4"
                                placeholder="Type here"
                                value={form.input_8}
                                onChange={e => {
                                  setForm({
                                    ...form,
                                    input_8: e.target.value,
                                  })
                                }}
                              ></textarea>
                            </div>
                            {formError.input_8 && (
                              <div className="error">
                                <span className="text-red">
                                  {formError.input_8}
                                </span>
                              </div>
                            )}
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="file-upload column reverse xsscreen2:w-full">
                              <span className="uppercase text-12 tracking-05em">
                                Upload your cv
                              </span>
                              <span className="text-[#CE0D0D] relative top-2">
                                *
                              </span>
                              <input
                                id="file-scr"
                                type="file"
                                onChange={e => {
                                  const path = e.target.value

                                  const filenameField =
                                    e.target.parentElement.querySelector(
                                      ".fileattach"
                                    )
                                  const filename = path.split(/\/|\\/).pop()

                                  const buttonField =
                                    e.target.parentElement.querySelector(
                                      "button"
                                    )
                                  if (filename)
                                    buttonField.innerText = "file attached"
                                  else buttonField.innerText = "attach cv"

                                  if (filename)
                                    filenameField.innerText = filename
                                  else filenameField.innerText = ""
                                  setFile(e.target.files[0])
                                  setForm({
                                    ...form,
                                    input_9: e.target.files[0],
                                  })
                                  setFormError({
                                    ...formError,
                                    input_9: "",
                                  })
                                }}
                              />

                              <label htmlFor="file-scr">
                                <button className="btn btn-border flex flex-wrap items-center justify-center gap-x-1">
                                  attach file{" "}
                                  <img
                                    src="../images/attach_file.svg"
                                    width={6}
                                    height={12}
                                    loading="lazy"
                                    alt="Attach File"
                                  />
                                </button>
                                <span className="fileattach uppercase text-14 tracking-05em opacity-40 mdscreen:mt-5">
                                  No file chosen
                                </span>
                              </label>
                              {formError.input_9 && (
                                <div className="error">
                                  <span className="text-red">
                                    {formError.input_9}
                                  </span>
                                </div>
                              )}
                            </div>
                          </li>
                          <li className="w-6/12 smscreen2:w-full">
                            <div className="file-upload column reverse xsscreen2:w-full">
                              <span className="uppercase text-12 tracking-05em">
                                Upload your ID/Passport
                              </span>
                              <span className="text-[#CE0D0D] relative top-2">
                                *
                              </span>
                              <input
                                id="file-scr2"
                                type="file"
                                onChange={e => {
                                  const path = e.target.value

                                  const filenameField =
                                    e.target.parentElement.querySelector(
                                      ".idattach"
                                    )
                                  const filename = path.split(/\/|\\/).pop()

                                  const buttonField =
                                    e.target.parentElement.querySelector(
                                      "button"
                                    )
                                  if (filename)
                                    buttonField.innerText = "file attached"
                                  else buttonField.innerText = "attach cv"

                                  if (filename)
                                    filenameField.innerText = filename
                                  else filenameField.innerText = ""
                                  setFile2(e.target.files[0])
                                  setForm({
                                    ...form,
                                    input_10: e.target.files[0],
                                  })
                                  setFormError({
                                    ...formError,
                                    input_10: "",
                                  })
                                }}
                              />

                              <label htmlFor="file-scr2">
                                <button className="btn btn-border flex flex-wrap items-center justify-center gap-x-1">
                                  attach file{" "}
                                  <img
                                    src="../images/attach_file.svg"
                                    width={6}
                                    height={12}
                                    loading="lazy"
                                    alt="Attach File"
                                  />
                                </button>
                                <span className="idattach uppercase text-14 tracking-05em opacity-40 mdscreen:mt-5">
                                  No file chosen
                                </span>
                              </label>
                              {formError.input_10 && (
                                <div className="error">
                                  <span className="text-red">
                                    {formError.input_10}
                                  </span>
                                </div>
                              )}
                            </div>
                          </li>
                        </ul>
                      </form>
                      <div className="flex justify-center formButton mt-80 lgscreen:mt-30">
                        <button
                          type="submit"
                          className="btn btn-black cursor-pointer"
                          onClick={() => {
                            var validRegex =
                              /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                            setFormError({
                              ...formError,
                              input_1:
                                form.input_1 === "" ? "Please enter name." : "",
                              input_3:
                                form.input_3 === ""
                                  ? "Please enter surname."
                                  : "",
                              input_4:
                                form.input_4 === "" ||
                                !form.input_4.match(validRegex)
                                  ? "Please enter valid email."
                                  : "",

                              input_5:
                                form.input_5 === ""
                                  ? "Please enter phone number."
                                  : "",
                              input_6:
                                form.input_6 === ""
                                  ? "Select year of experience"
                                  : "",
                              input_11:
                                form.input_11 === "" ? "Select position" : "",
                              input_8:
                                form.input_8 === ""
                                  ? "Please enter message"
                                  : "",
                              input_9:
                                form.input_9 === "" ? "Please upload file" : "",
                              input_10:
                                form.input_10 === ""
                                  ? "Please upload file"
                                  : "",
                            })

                            if (
                              form.input_1 !== "" &&
                              form.input_3 !== "" &&
                              form.input_4 !== "" &&
                              form.input_5 !== "" &&
                              form.input_6 !== "" &&
                              form.input_11 !== "" &&
                              form.input_8 !== "" &&
                              form.input_9 !== "" &&
                              form.input_10 !== ""
                            ) {
                              if (
                                prevEntries.filter(
                                  entry =>
                                    entry["4"] === form.input_4 &&
                                    entry["11"] === form.input_11
                                ).length < 1 &&
                                !isLoading
                              ) {
                                document.body.classList.add("loader")
                                setIsLoading(true)

                                const formData = new FormData()
                                formData.append("input_1", form.input_1)
                                formData.append("input_3", form.input_3)
                                formData.append("input_4", form.input_4)
                                formData.append("input_5", form.input_5)
                                formData.append("input_6", form.input_6)
                                formData.append("input_11", form.input_11)
                                formData.append("input_8", form.input_8)
                                formData.append("input_9", file)
                                formData.append("input_10", file2)
                                const requestOptions = {
                                  method: "POST",
                                  body: formData,
                                }

                                const url = `${
                                  process.env.GATSBY_SITE_URL
                                }wp-json/gf/v2/forms/${
                                  form.input_11 === "Content Manager"
                                    ? process.env
                                        .GATSBY_CONTENT_MANAGER_APPLICATION_FORM_ID
                                    : process.env
                                        .GATSBY_GENERAL_APPLICATION_FORM_ID
                                }/submissions`
                                fetch(url, requestOptions).then(response => {
                                  if (response.status === 200) {
                                    document.body.classList.remove("loader")
                                    setIsLoading(false)
                                    setHasSubmitted(true)
                                  } else {
                                    setFormError({
                                      ...formError,
                                    })
                                  }
                                })
                              } else if (
                                prevEntries.filter(
                                  entry =>
                                    entry["4"] === form.input_4 &&
                                    entry["11"] === form.input_11
                                ).length < 1 &&
                                isLoading
                              ) {
                                console.log("wait")
                              } else {
                                setHasSubmitted(true)
                              }
                            }
                          }}
                        >
                          {isLoading
                            ? "Sending Application..."
                            : "Send Application"}
                        </button>
                      </div>
                      <div className="newsletter-form mt-10"></div>
                    </motion.div>
                  </div>
                ) : prevEntries.filter(
                    entry =>
                      entry["4"] === form.input_4 &&
                      entry["11"] === form.input_11
                  ).length < 1 ? (
                  <div className="mt-20">
                    <p>
                      Thank you for your interest in joining the collection. Our
                      team will get back to you shortly.
                    </p>
                  </div>
                ) : (
                  <div className="mt-20">
                    <p>
                      We have already received your application for this
                      position.
                    </p>
                  </div>
                )}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default ApplicationForm
export const PageApplicationFormFragment = graphql`
  fragment PageApplicationFormFragment on WpPage_Pagecontent_PageContent_ApplicationForm {
    extraId
    extraClass
    hideSection
    heading
    preHeading
    description
  }
`
